import { useEffect } from "react";
import "./index.css";
import "swiper/css";
import "swiper/css/navigation";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { Helmet } from "react-helmet-async";

const AboutUs = () => {
  const { setActiveRoute, setActiveSection } = useContext(AppContext);

  useEffect(() => {
    setActiveRoute("/about-us");
    setActiveSection("");
  }, [setActiveRoute, setActiveSection]);

  return (
    <div className="ibix-about-us">
      <Helmet>
        <title>
          IBIX Qodify | Premier Software Training Institute in Hyderabad
        </title>
        <meta
          name="description"
          content="IBIX Qodify is Hyderabad's premier software training institute, offering industry-vetted programs in Full Stack, Data Science, Cloud Computing & more. Transform your career with expert mentorship and real-world projects."
        />
        <meta
          property="og:title"
          content="IBIX Qodify - Transform Your Tech Career"
        />
        <meta
          property="og:description"
          content="Join Hyderabad's leading software training institute. Industry-vetted curriculum, expert mentors from top tech companies, and guaranteed career growth."
        />
      </Helmet>

      {/* 3D ANIMATED AI HEADER - IBIX Qodify Technologies */}
      <section className="ibix-three-d-hero">
        <div className="ibix-digital-particles"></div>
        <div className="ibix-corporate-building-bg"></div>
        <div className="ibix-container ibix-brand-3d-wrapper">
          <h1 className="ibix-ai-3d-text">IBIX Qodify</h1>
          <div className="ibix-ai-3d-sub">Technologies</div>
          <div className="ibix-ai-neural-tagline">
            Industry 4.0 · AI · ML · Data Science · Cyber Security · Full Stack
          </div>
        </div>
      </section>

      {/* Corporate Office Environment - Employee Discussions */}
      <section className="ibix-corporate-environment-section">
        <div className="ibix-container">
          <div className="ibix-section-header">
            <span className="ibix-section-tag">Real Corporate Environment</span>
            <h2 className="ibix-section-title">Where Professionals Thrive</h2>
            <p className="ibix-section-description">
              Step into our state-of-the-art corporate campus designed for
              innovation, collaboration, and excellence
            </p>
          </div>

          <div className="ibix-corporate-grid">
            <div className="ibix-corporate-card ibix-large">
              <div
                className="ibix-corporate-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773822500/photo-1497366216548-37526070297c_bvelhb.jpg')",
                }}
              >
                <div className="ibix-image-overlay"></div>
                <div className="ibix-corporate-content">
                  <h3>Modern Headquarters</h3>
                  <p>
                    10,000 sq.ft innovation hub in Hyderabad's tech corridor
                  </p>
                </div>
              </div>
            </div>
            <div className="ibix-corporate-card">
              <div
                className="ibix-corporate-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773822658/photo-1522071820081-009f0129c71c_kqe17g.jpg')",
                }}
              >
                <div className="ibix-image-overlay"></div>
                <div className="ibix-corporate-content">
                  <h3>Team Collaboration</h3>
                  <p>Agile squads working on real client projects</p>
                </div>
              </div>
            </div>
            <div className="ibix-corporate-card">
              <div
                className="ibix-corporate-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773822708/photo-1552664730-d307ca884978_eg6rpi.jpg')",
                }}
              >
                <div className="ibix-image-overlay"></div>
                <div className="ibix-corporate-content">
                  <h3>Executive Discussion</h3>
                  <p>Mentors from Google, Microsoft guiding learners</p>
                </div>
              </div>
            </div>
            <div className="ibix-corporate-card">
              <div
                className="ibix-corporate-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773822756/photo-1542744173-8e7e53415bb0_eoxdvr.jpg')",
                }}
              >
                <div className="ibix-image-overlay"></div>
                <div className="ibix-corporate-content">
                  <h3>Strategy Meeting</h3>
                  <p>Industry-aligned curriculum planning</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industry 4.0 Tech Stack - AI/ML, Data Science, Cyber Security, Full Stack */}
      <section className="ibix-tech-showcase-section">
        <div className="ibix-container">
          <div className="ibix-section-header">
            <span className="ibix-section-tag">Industry 4.0 Technologies</span>
            <h2 className="ibix-section-title">Future-Ready Skills</h2>
            <p className="ibix-section-description">
              Master the technologies that define the next decade of innovation
            </p>
          </div>

          <div className="ibix-tech-grid">
            <div className="ibix-tech-card" data-ibix-tech="ai-ml">
              <div className="ibix-tech-icon">🧠</div>
              <h3>AI & Machine Learning</h3>
              <p>
                Neural networks, deep learning, computer vision, NLP, and
                generative AI with real-world applications
              </p>
              <div className="ibix-tech-stats">
                <span>45+ Projects</span>
                <span>Industry Partners: 12</span>
              </div>
            </div>

            <div className="ibix-tech-card" data-ibix-tech="data-science">
              <div className="ibix-tech-icon">📊</div>
              <h3>Data Science & Analytics</h3>
              <p>
                Big data, predictive modeling, data visualization, and business
                intelligence using Python, R, and Tableau
              </p>
              <div className="ibix-tech-stats">
                <span>38+ Projects</span>
                <span>Industry Partners: 15</span>
              </div>
            </div>

            <div className="ibix-tech-card" data-ibix-tech="cyber-security">
              <div className="ibix-tech-icon">🔒</div>
              <h3>Cyber Security</h3>
              <p>
                Ethical hacking, penetration testing, network security,
                cryptography, and incident response
              </p>
              <div className="ibix-tech-stats">
                <span>25+ Labs</span>
                <span>Certifications: CEH, CISSP</span>
              </div>
            </div>

            <div className="ibix-tech-card" data-ibix-tech="full-stack">
              <div className="ibix-tech-icon">💻</div>
              <h3>Full Stack Development</h3>
              <p>
                MERN, MEAN, Java Spring, microservices, cloud deployment, and
                DevOps practices
              </p>
              <div className="ibix-tech-stats">
                <span>60+ Projects</span>
                <span>Real-time Applications</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Real-Time Projects Showcase */}
      <section className="ibix-projects-showcase-section">
        <div className="ibix-container">
          <div className="ibix-section-header">
            <span className="ibix-section-tag">Real-Time Projects</span>
            <h2 className="ibix-section-title">
              Built by Learners, Used by Industry
            </h2>
            <p className="ibix-section-description">
              Our students don't just learn — they build production-ready
              applications that solve real business problems
            </p>
          </div>

          <div className="ibix-projects-grid">
            <div className="ibix-project-card">
              <div
                className="ibix-project-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773822850/photo-1551288049-bebda4e38f71_t2uokm.jpg')",
                }}
              >
                <div className="ibix-project-tag">AI/ML</div>
              </div>
              <div className="ibix-project-details">
                <h4>Medical Imaging Diagnostic AI</h4>
                <p>
                  Deep learning model achieving 94% accuracy in early detection
                  of anomalies. Deployed at partner hospitals.
                </p>
                <div className="ibix-project-meta">
                  <span>Python · TensorFlow · OpenCV</span>
                  <span className="ibix-project-company">Apollo Hospitals</span>
                </div>
              </div>
            </div>

            <div className="ibix-project-card">
              <div
                className="ibix-project-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773822898/photo-1460925895917-afdab827c52f_bxjlad.jpg')",
                }}
              >
                <div className="ibix-project-tag">Data Science</div>
              </div>
              <div className="ibix-project-details">
                <h4>Supply Chain Demand Forecasting</h4>
                <p>
                  Predictive analytics platform reducing inventory costs by 23%
                  for a leading logistics firm.
                </p>
                <div className="ibix-project-meta">
                  <span>Python · Prophet · Power BI</span>
                  <span className="ibix-project-company">Delhivery</span>
                </div>
              </div>
            </div>

            <div className="ibix-project-card">
              <div
                className="ibix-project-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773823050/photo-1563986768609-322da13575f3_kfndzr.jpg')",
                }}
              >
                <div className="ibix-project-tag">Cyber Security</div>
              </div>
              <div className="ibix-project-details">
                <h4>Enterprise Security Operations Center</h4>
                <p>
                  Real-time threat detection and response system protecting 50+
                  SMEs from cyber attacks.
                </p>
                <div className="ibix-project-meta">
                  <span>SIEM · Wireshark · Kali Linux</span>
                  <span className="ibix-project-company">Quick Heal</span>
                </div>
              </div>
            </div>

            <div className="ibix-project-card">
              <div
                className="ibix-project-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773823098/photo-1551650975-87deedd944c3_lksewo.jpg')",
                }}
              >
                <div className="ibix-project-tag">Full Stack</div>
              </div>
              <div className="ibix-project-details">
                <h4>Fintech Dashboard for Micro-Loans</h4>
                <p>
                  Complete loan management platform processing ₹2Cr+ in
                  disbursals for NBFC partners.
                </p>
                <div className="ibix-project-meta">
                  <span>React · Node.js · MongoDB</span>
                  <span className="ibix-project-company">BharatPe</span>
                </div>
              </div>
            </div>

            <div className="ibix-project-card">
              <div
                className="ibix-project-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773823158/photo-1581291518633-83b4ebd1d83e_o508ie.jpg')",
                }}
              >
                <div className="ibix-project-tag">AI/ML</div>
              </div>
              <div className="ibix-project-details">
                <h4>Intelligent Recruitment Assistant</h4>
                <p>
                  AI-powered resume screening and candidate matching tool used
                  by 30+ HR teams.
                </p>
                <div className="ibix-project-meta">
                  <span>NLP · spaCy · Flask</span>
                  <span className="ibix-project-company">Randstad</span>
                </div>
              </div>
            </div>

            <div className="ibix-project-card">
              <div
                className="ibix-project-image"
                style={{
                  backgroundImage:
                    "url('https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773823295/photo-1558494949-ef010cbdcc31_kfipmc.jpg')",
                }}
              >
                <div className="ibix-project-tag">Cyber Security</div>
              </div>
              <div className="ibix-project-details">
                <h4>Blockchain-Based Identity Management</h4>
                <p>
                  Decentralized identity solution for secure KYC processes in
                  banking sector.
                </p>
                <div className="ibix-project-meta">
                  <span>Ethereum · Hyperledger · IPFS</span>
                  <span className="ibix-project-company">ICICI Bank</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section className="ibix-about-hero">
        <div className="ibix-hero-overlay"></div>
        <div className="ibix-hero-content ibix-container">
          <h1 className="ibix-hero-title">Shaping Tomorrow's Tech Leaders</h1>
          <p className="ibix-hero-subtitle">
            India's Premier Software Training Institute, Bridging the Gap
            Between Academic Excellence and Industry Innovation
          </p>
          <div className="ibix-hero-stats">
            <div className="ibix-stat-item">
              <span className="ibix-stat-number">5000+</span>
              <span className="ibix-stat-label">Students Trained</span>
            </div>
            <div className="ibix-stat-item">
              <span className="ibix-stat-number">95%</span>
              <span className="ibix-stat-label">Placement Rate</span>
            </div>
            <div className="ibix-stat-item">
              <span className="ibix-stat-number">50+</span>
              <span className="ibix-stat-label">Expert Mentors</span>
            </div>
          </div>
        </div>
      </section>

      {/* CEO Message - Elevated */}
      <section className="ibix-ceo-section">
        <div className="ibix-container">
          <div className="ibix-ceo-grid">
            <div className="ibix-ceo-content">
              <span className="ibix-section-tag">Leadership</span>
              <h2 className="ibix-section-title">Message from Our Founder</h2>
              <div className="ibix-ceo-message-card">
                <div className="ibix-quote-icon">"</div>
                <p className="ibix-ceo-message">
                  Welcome to IBIX Qodify Technologies. In today's rapidly
                  evolving tech landscape, traditional education alone isn't
                  enough. We've built IBIX to be the catalyst that transforms
                  passionate learners into industry-ready professionals. Our
                  commitment goes beyond teaching code – we nurture
                  problem-solvers, innovators, and future tech leaders.
                </p>
                <p className="ibix-ceo-message">
                  Every curriculum we design, every mentor we onboard, and every
                  project we include is carefully vetted to meet real industry
                  demands. We don't just prepare you for jobs; we prepare you
                  for impactful careers.
                </p>
                <div className="ibix-ceo-signature">
                  <strong>Jelani Basha</strong>
                  <span>Founder & CEO, IBIX Qodify Technologies</span>
                </div>
              </div>
            </div>
            <div className="ibix-ceo-stats-grid">
              <div className="ibix-stat-card">
                <h3>15+</h3>
                <p>Years of Industry Experience</p>
              </div>
              <div className="ibix-stat-card">
                <h3>100+</h3>
                <p>Partner Companies</p>
              </div>
              <div className="ibix-stat-card">
                <h3>40+</h3>
                <p>Expert Mentors</p>
              </div>
              <div className="ibix-stat-card">
                <h3>24/7</h3>
                <p>Learning Support</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="ibix-mission-vision-section">
        <div className="ibix-container">
          <div className="ibix-mission-vision-grid">
            <div className="ibix-mission-card">
              <div className="ibix-card-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                To democratize tech education and create a seamless pathway from
                learning to earning. We're committed to bridging the
                industry-academia gap through innovative teaching methodologies
                and real-world project experience.
              </p>
            </div>
            <div className="ibix-vision-card">
              <div className="ibix-card-icon">⭐</div>
              <h3>Our Vision</h3>
              <p>
                To be the most trusted partner in tech career transformation
                across India, recognized for producing job-ready professionals
                who lead innovation at the world's most prestigious technology
                companies.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do - Enhanced */}
      <section className="ibix-offerings-section">
        <div className="ibix-container">
          <div className="ibix-section-header">
            <span className="ibix-section-tag">Our Approach</span>
            <h2 className="ibix-section-title">The IBIX Advantage</h2>
            <p className="ibix-section-description">
              A comprehensive ecosystem designed for your success
            </p>
          </div>

          <div className="ibix-offerings-grid">
            <div className="ibix-offering-card">
              <div className="ibix-offering-icon">👨‍💻</div>
              <h3>Expert-Led Instruction</h3>
              <p>
                Learn from senior engineers and architects from Google, Amazon,
                Meta, and Microsoft through live interactive sessions.
              </p>
            </div>
            <div className="ibix-offering-card">
              <div className="ibix-offering-icon">🤝</div>
              <h3>1:1 Mentorship</h3>
              <p>
                Personalized guidance from industry veterans who've solved
                real-world problems at scale.
              </p>
            </div>
            <div className="ibix-offering-card">
              <div className="ibix-offering-icon">🚀</div>
              <h3>Career Acceleration</h3>
              <p>
                End-to-end career support including resume optimization, mock
                interviews, and direct referrals.
              </p>
            </div>
            <div className="ibix-offering-card">
              <div className="ibix-offering-icon">🌐</div>
              <h3>Global Community</h3>
              <p>
                Connect with a diverse network of learners, alumni, and mentors
                across 15+ countries.
              </p>
            </div>
            <div className="ibix-offering-card">
              <div className="ibix-offering-icon">💼</div>
              <h3>Real Projects</h3>
              <p>
                Build production-ready applications that solve actual business
                problems, not just academic exercises.
              </p>
            </div>
            <div className="ibix-offering-card">
              <div className="ibix-offering-icon">📊</div>
              <h3>Industry-Vetted Curriculum</h3>
              <p>
                Courses designed in collaboration with hiring managers from top
                tech companies.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Team - Professional Redesign */}
      <section className="ibix-team-section">
        <div className="ibix-container">
          <div className="ibix-section-header">
            <span className="ibix-section-tag">Leadership</span>
            <h2 className="ibix-section-title">Meet Our Core Team</h2>
            <p className="ibix-section-description">
              Industry veterans committed to your growth
            </p>
          </div>

          <div className="ibix-team-grid">
            <div className="ibix-team-member-card">
              <div className="ibix-member-image-wrapper">
                <img
                  src="https://res.cloudinary.com/dkkzdkikd/image/upload/v1773403215/WhatsApp_Image_2025-11-26_at_11.51.52_AM_m9fdpp.jpg"
                  alt="Raj-kumar"
                  className="ibix-member-image"
                />
              </div>
              <h4>M Raju</h4>
              <p className="ibix-member-position">Co-Founder</p>
              <p className="ibix-member-company">IBIX Qodify</p>
              <div className="ibix-member-expertise">
                Database Management • SQL
              </div>
            </div>

            <div className="ibix-team-member-card">
              <div className="ibix-member-image-wrapper">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/3945ade943cf47838e4c67e36ea8a07c.png"
                  alt="Kalesha"
                  className="ibix-member-image"
                />
              </div>
              <h4>Kalesha</h4>
              <p className="ibix-member-position">Senior Architect</p>
              <p className="ibix-member-company">Cognizant</p>
              <div className="ibix-member-expertise">Data Analyst • Azure</div>
            </div>

            <div className="ibix-team-member-card">
              <div className="ibix-member-image-wrapper">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/24b168a51f324b7d9f67bbd956c46805.jpeg"
                  alt="Nihaara Simrat"
                  className="ibix-member-image"
                />
              </div>
              <h4>Nihaara Simrat</h4>
              <p className="ibix-member-position">Tech Lead</p>
              <p className="ibix-member-company">Google</p>
              <div className="ibix-member-expertise">
                AI/ML • MLOps Engineer
              </div>
            </div>

            <div className="ibix-team-member-card">
              <div className="ibix-member-image-wrapper">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/72b9623546d34cee961e5f8ec1d9c0de.png"
                  alt="Fariyad"
                  className="ibix-member-image"
                />
              </div>
              <h4>Fariyad</h4>
              <p className="ibix-member-position">Principal Engineer</p>
              <p className="ibix-member-company">Ex. HCL</p>
              <div className="ibix-member-expertise">DevOps • SRE</div>
            </div>

            <div className="ibix-team-member-card">
              <div className="ibix-member-image-wrapper">
                <img
                  src="https://res.cloudinary.com/dyvxdlyrr/image/upload/v1773824068/download_1_bmhce8.png"
                  alt="Abdul Kareem"
                  className="ibix-member-image"
                />
              </div>
              <h4>Shivansh Darsh</h4>
              <p className="ibix-member-position">Solutions Architect</p>
              <p className="ibix-member-company">Ex. IBM</p>
              <div className="ibix-member-expertise">Enterprise • Java</div>
            </div>

            <div className="ibix-team-member-card">
              <div className="ibix-member-image-wrapper">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/0d490aa3dd2b4910abd268a770f5db1e.jpg"
                  alt="Balaram"
                  className="ibix-member-image"
                />
              </div>
              <h4>Balaram</h4>
              <p className="ibix-member-position">Senior Developer</p>
              <p className="ibix-member-company">Infosys</p>
              <div className="ibix-member-expertise">React • Node.js</div>
            </div>

            <div className="ibix-team-member-card">
              <div className="ibix-member-image-wrapper">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/ba73b20b0d7d4869994030942e4cbae2.jpeg"
                  alt="Akshada"
                  className="ibix-member-image"
                />
              </div>
              <h4>Akshada</h4>
              <p className="ibix-member-position">Tech Lead</p>
              <p className="ibix-member-company">Ex. Infosys</p>
              <div className="ibix-member-expertise">Python • Django</div>
            </div>
          </div>
        </div>
      </section>

      {/* NRI Community - Global Presence */}
      <section className="ibix-global-presence-section">
        <div className="ibix-container">
          <div className="ibix-section-header">
            <span className="ibix-section-tag">Global Community</span>
            <h2 className="ibix-section-title">Our International Network</h2>
            <p className="ibix-section-description">
              Connecting tech talent across continents
            </p>
          </div>

          <div className="ibix-global-grid">
            <div className="ibix-global-card">
              <div className="ibix-global-member-image">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/a7a534c732e44822b6ac50ab42b51688.png"
                  alt="Samuel Mugisha"
                />
              </div>
              <div className="ibix-global-member-info">
                <h4>Samuel Mugisha</h4>
                <div className="ibix-member-location">
                  <span>Cameroon</span>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/64cac3cf72664419ab5304459d6ded8e.png"
                    alt="Cameroon Flag"
                    className="ibix-country-flag"
                  />
                </div>
                <p className="ibix-member-role">Technical Mentor</p>
              </div>
            </div>

            <div className="ibix-global-card">
              <div className="ibix-global-member-image">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/f540b565c03342d3a6fbe3e74aecbd7a.png"
                  alt="Vivek Sharma"
                />
              </div>
              <div className="ibix-global-member-info">
                <h4>Vivek Sharma</h4>
                <div className="ibix-member-location">
                  <span>Canada</span>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/5ade2cdcc5514f02beb085351696671b.png"
                    alt="Canada Flag"
                    className="ibix-country-flag"
                  />
                </div>
                <p className="ibix-member-role">Cloud Architect</p>
              </div>
            </div>

            <div className="ibix-global-card">
              <div className="ibix-global-member-image">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/380e5d012f314bc2877897b607b5db7c.jpg"
                  alt="Rounaq"
                />
              </div>
              <div className="ibix-global-member-info">
                <h4>Rounaq</h4>
                <div className="ibix-member-location">
                  <span>Dubai, UAE</span>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/f4e300aee9e64a7dadbfc1638d3601cd.png"
                    alt="UAE Flag"
                    className="ibix-country-flag"
                  />
                </div>
                <p className="ibix-member-role">Product Manager</p>
              </div>
            </div>

            <div className="ibix-global-card">
              <div className="ibix-global-member-image">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/bce9a0786aa14c71bf65e8d68727a673.png"
                  alt="ALI"
                />
              </div>
              <div className="ibix-global-member-info">
                <h4>Ali Al-Saud</h4>
                <div className="ibix-member-location">
                  <span>Saudi Arabia</span>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/2a5d6296e9474f0bb87f5926a4834080.png"
                    alt="Saudi Arabia Flag"
                    className="ibix-country-flag"
                  />
                </div>
                <p className="ibix-member-role">Data Scientist</p>
              </div>
            </div>

            <div className="ibix-global-card">
              <div className="ibix-global-member-image">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/3b23eabed80e436c8c467c74701071c2.jpeg"
                  alt="Carmelita James"
                />
              </div>
              <div className="ibix-global-member-info">
                <h4>Carmelita James</h4>
                <div className="ibix-member-location">
                  <span>Philippines</span>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/db553c605ffd4c6fa099c1e805b50321.png"
                    alt="Philippines Flag"
                    className="ibix-country-flag"
                  />
                </div>
                <p className="ibix-member-role">UX Strategist</p>
              </div>
            </div>

            <div className="ibix-global-card">
              <div className="ibix-global-member-image">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/ed82edae525b4383bf94b7fcdd3b7120.jpg"
                  alt="Shrestha Mark"
                />
              </div>
              <div className="ibix-global-member-info">
                <h4>Shrestha Mark</h4>
                <div className="ibix-member-location">
                  <span>Australia</span>
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/d27fb3f74ec44e3dbbc4a17540bf2284.png"
                    alt="Australia Flag"
                    className="ibix-country-flag"
                  />
                </div>
                <p className="ibix-member-role">DevOps Engineer</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="ibix-cta-section">
        <div className="ibix-container">
          <div className="ibix-cta-content">
            <h2>Ready to Transform Your Career?</h2>
            <p>
              Join 5000+ successful professionals who've accelerated their tech
              careers with IBIX
            </p>
            <div className="ibix-cta-buttons">
              <a
                href="https://ibixqt.in/courses/specializations"
                target="_blank"
                rel="noopener noreferrer"
                className="ibix-btn-primary"
              >
                Explore Programs
              </a>
              <a
                href="https://api.whatsapp.com/send/?phone=919498652542&text=Hi%20I%20am%20interested%20in%20your%20courses&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="ibix-btn-secondary"
              >
                Schedule a Call
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
